export default {
    userName: ({ apptData }) => {
        // @TODO - user name needs to be stored in ApptType
        // for now we have to use this hackiness
        return apptData.title.replace('Appointment with ', '');
    },
};
